import * as React from 'react';
import { Grid } from '../bootstrap-components/BootstrapComponents';
import { getSite } from '../../infrastructure/site/SiteProvider';

export interface PageTitleProps {
    title: string;
    children?: any;
}

export function PageTitle (props: PageTitleProps) {
    document.title = getSite().navn + ' - ' + props.title;
    return (
      <div id='page-title'>
          <Grid>
            <div className='notification-container' />
            <h1>{props.title}</h1>  
            {props.children}            
          </Grid>
      </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/PageTitle.tsx